import React, { useRef } from 'react';
import useWindowSize from '../../../../hooks/useWindowSize';
// import { useParams } from 'react-router-dom';
// import { useUser } from '../../../../hooks/useUser';
import {
  ResponsiveContainer,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Line,
} from 'recharts';
import { ChartPlaceholder } from '../../../../components';
import {
  getScenarioColor,
  yearRowIsValid,
  valueFormatter,
  // updateScenarioGraph,
} from './helperFunctions';

//this is the graph to compare the three scenarios, in the projections tab

export default function ScenarioGraph({ data, scenarios, label, unit = '$' }) {
  // const { user } = useUser();
  // const { propertyId } = useParams();
  // Validate data

  const isPropertyDataValid = data && data.every(yearRowIsValid);
  const { width } = useWindowSize();

  const graphHeight = width > 640 ? 400 : 300;

  // Update chart SVG in the dabatase every time data changes
  const chartRef = useRef(null);

  //stop updating chart in the DB for now
  // useEffect(() => {
  //   // convert rechat data to svg
  //   setTimeout(() => {
  //     if (chartRef.current && chartRef.current.container && data.length === 5) {
  //       //get svg element from recharts
  //       const chartSVG = chartRef.current.container.firstChild;
  //       // convert recharts svg to simple svg so we can use it in html
  //       //change width to 100% so it can be responsive
  //       chartSVG.setAttribute('width', '100%');
  //       const svgXML = new XMLSerializer().serializeToString(chartSVG);
  //       // update chart in the DB to use in drafts
  //       return updateScenarioGraph(user.uid, propertyId, type, svgXML);
  //     }
  //   }, 1000);
  // }, [scenarios, data, chartRef.current]);

  return (
    <div className="w-full h-full pb-3 pl-8 text-md">
      {isPropertyDataValid && data ? (
        <>
          <h2 className="mt-3 mb-2 text-lg pb-8 text-center font-medium text-black -mr-6">
            {label}
          </h2>
          <ResponsiveContainer width="90%" height={graphHeight}>
            <LineChart data={data} ref={chartRef} c>
              <CartesianGrid stroke="eee" strokeDasharray="3 3" />
              <XAxis dataKey="date" tickMargin={8} />
              <YAxis
                width={85}
                tickFormatter={(tick) => valueFormatter(tick, unit)}
                type="number"
                style={{ fontSize: '14px' }}
              />
              <Tooltip formatter={(value) => valueFormatter(value, unit)} />
              {/* <Legend className="ml-8"/> */}

              <Line
                type="monotone"
                strokeWidth={1.5}
                dataKey={'BRRRR Scenario'}
                stroke={getScenarioColor('BRRRR Scenario')}
                activeDot={{ r: 6 }}
              />
              <Line
                type="monotone"
                strokeWidth={1.5}
                dataKey={'On Purchase'}
                stroke={getScenarioColor('On Purchase')}
                activeDot={{ r: 6 }}
              />
              <Line
                type="monotone"
                strokeWidth={1.5}
                dataKey={'Buy and Hold'}
                stroke={getScenarioColor('Buy and Hold')}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </>
      ) : (
        <div className="text-center mt-16 ml-10 mb-4">
          <h3 className="text-center text-xl font-medium text-neutral-900">
            Chart
          </h3>
          <p className="py-1 text-neutral-500 text-center">
            Please add information about your purchase, expenses and monthly
            income in property details to see your scenarios on the chart.
          </p>
          <ChartPlaceholder />
        </div>
      )}
    </div>
  );
}
